const WEB_PROTOCOLS = new Set(["http:", "https:"])

// Whether a stored URL may become a link. Websites and profile URLs come from
// scraping and from agents reading third-party pages, so nothing guarantees
// their scheme: a `javascript:` value would run on click, and React only warns.
export function isHttpUrl(url: string | null | undefined): url is string {
  if (!url) return false
  try {
    return WEB_PROTOCOLS.has(new URL(url).protocol)
  } catch {
    return false
  }
}
